<div class="flex flex-col items-center justify-center h-full">
  <h1 class="text-4xl font-bold mb-4">404 - Page Not Found</h1>
  <p class="text-lg mb-8">Oops! The page you are looking for does not exist.</p>
  <button
    class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
    (click)="goBack()"
  >
    Go Back
  </button>
</div>
